export const SEARCH_FOCUS = 'SEARCH_FOCUS'
export const SEARCH_BLUR = 'SEARCH_BLUR'
export const CHANGE_HOT_LIST = 'CHANGE_HOT_LIST'
export const MOUSE_ENTER = 'MOUSE_ENTER'
export const MOUSE_LEAVE = 'MOUSE_LEAVE'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CLICK_BAR_BTN = 'CLICK_BAR_BTN'